import {css, DSButton, Row} from "@cdx/ds";
import {VisionBoardBag} from "./canvas-utils";
import UndoButtons from "./UndoButtons";
import {useFilePaster} from "../card-container/FilePasteHandler";
import {handleCanvasFileDrop} from "./process-image";
import {createCardNode, createFilterNode, createTextNode} from "./canvas-node-utils";
import {ArrowOverlay, DropDownForChild} from "@cdx/common";
import CardPicker from "../../components/CardPicker";
import {useRoot} from "../../lib/mate/mate-utils";
import {CardId} from "../../cdx-models/Card";
import {getMySelectedProjectIds} from "../../lib/hooks/useSelectedProjects";

const CardPickOverlay = ({overlayProps, bag}: {overlayProps: any; bag: VisionBoardBag}) => {
  const root = useRoot();
  const projectIds = getMySelectedProjectIds(bag.root);

  return (
    <ArrowOverlay arrowSize="sm" {...overlayProps} className={css({px: "12px"})}>
      <CardPicker
        topBoxProps={{bg: "white", pa: 2, rounded: "sm"}}
        label="Search for card title"
        onSelect={(id: CardId) => {
          createCardNode(bag, id);
          overlayProps.close();
        }}
        root={root}
        filter={{visibility: "default", deck: {projectId: projectIds}}}
        emptyMessage="The search exludes private and archived cards."
        limit={5}
      />
    </ArrowOverlay>
  );
};

const AddCardNodeButton = ({bag}: {bag: VisionBoardBag}) => (
  <DropDownForChild
    setChildProps={({isOpen}: any) => ({
      active: isOpen,
    })}
    renderOverlay={(overlayProps: any) => <CardPickOverlay overlayProps={overlayProps} bag={bag} />}
    overlayProps={{placement: "bottom", distanceFromAnchor: 10}}
  >
    <DSButton>Add Card</DSButton>
  </DropDownForChild>
);

// const GridPicker = ({bag}: {bag: VisionBoardBag}) => {
//   const options = useCanvasOptions(bag.store);
//   if (options.grid === 20) return null;
//   return (
//     <DSSelect
//       size="sm"
//       options={
//         [
//           {label: "No Grid", value: 1},
//           {label: "10px", value: 10},
//           {label: "20px", value: 20},
//         ] as const
//       }
//       value={options.grid ?? 1}
//       onChange={(val) => setCanvasOption(bag.store, "grid", val as 20)}
//     />
//   );
// };

type CanvasActionButtonProps = {bag: VisionBoardBag};
const CanvasActionButtons = ({bag}: CanvasActionButtonProps) => {
  const handleAddTextNode = () => {
    const {id} = createTextNode(bag);
    bag.selectionStore.setNodeIds([id]);
  };

  const handleAddFilterNode = () => {
    const {id} = createFilterNode(bag);
    bag.selectionStore.setNodeIds([id]);
  };

  useFilePaster((files) => files.forEach((file) => handleCanvasFileDrop(file, bag)));

  return (
    <Row sp="4px">
      <DSButton onClick={handleAddTextNode}>Add Text</DSButton>
      <AddCardNodeButton bag={bag} />
      <DSButton onClick={handleAddFilterNode}>Add Smart Card View</DSButton>
      <UndoButtons store={bag.store} />
    </Row>
  );
};

export default CanvasActionButtons;
